import React, { Component } from "react";
import ReactTable from "react-table";

import * as notify from "../../../../shared/notify";
import { Input } from "../../../form-inputs/inputs";
import { searchReferences } from "../../lib/referenceData";

import { searchRefColumns, currentRefColumns } from "./constants";
import "./_select-references.scss";
import { each } from "lodash";

class SelectReferences extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchParams: {},
            readableParams: "",
            searchReferences: [],
            selectedReferences: props.references,
            selectedOrders: [1, 2, 3, 4],
        };
    }

    isValidParams(searchParams) {
        let isValid = false;
        Object.keys(searchParams).forEach((param) => {
            if (searchParams[param]) {
                isValid = true;
            }
        });

        return isValid;
    }

    mergeReferencesWithSelected = (searchRefs, selectedRefs, key = null) => {
        const selectedKeys = selectedRefs.map((refer) => refer.key);
        var orderAlreadyExists = selectedRefs.map((refer) => refer.order);
        each(orderAlreadyExists, (num) => {
            this.removeOrderFromList(num);
        });

        return searchRefs.map((ref) => {
            if (ref.key === key) {
                ref.order = 0;
            }

            return {
                ...ref,
                isChecked: selectedKeys.includes(ref.key),
            };
        });
    };

    onSearch = async (e) => {
        e.preventDefault();
        const searchParams = {
            description: document.getElementById("search_description").value,
            manufacturer: document.getElementById("search_manufacturer").value, //'Kraft'
            brand: document.getElementById("search_brand").value,
            upc: document.getElementById("search_upc").value, //'087076645397',
        };

        this.setState({
            searchParams: searchParams,
            readableParams: this.displayReadableParams(searchParams),
        });

        if (this.isValidParams(searchParams)) {
            const response = await searchReferences(searchParams);

            this.setState({
                searchReferences: this.mergeReferencesWithSelected(
                    response.filter((r) => r.key !== this.props.wipKey),
                    this.state.selectedReferences
                ),
            });
        } else {
            notify.error("Please enter a search term");
        }
    };

    displayReadableParams(params) {
        const readableParams = Object.keys(params)
            .filter((param) => params[param])
            .map((param) => `${param} = ${params[param]}`)
            .join(", ");

        return readableParams;
    }

    removeReference = (selection) => {
        const references = this.state.selectedReferences;
        this.props.deleteReference(this.props.wipKey, selection.key, this.props.taskKey);
        const newReferences = references.filter((ref) => {
            return ref.key !== selection.key;
        });

        if (selection.order !== 0) {
            this.addOrderToList(selection.order);
        }

        this.setState({
            searchReferences: this.mergeReferencesWithSelected(this.state.searchReferences, newReferences, selection.key),
            selectedReferences: newReferences,
        });
    };

    addReference = (selection) => {
        const references = this.state.selectedReferences;

        if (
            references.find((ref) => {
                return selection.key === ref.key;
            })
        ) {
            return;
        }

        if (selection.order === 0 && this.state.selectedOrders.length > 0) {
            var orderNumber = Math.min(...this.state.selectedOrders);
            selection.order = orderNumber;
            this.removeOrderFromList(orderNumber);
        }

        references.push(selection);
        this.setState({
            searchReferences: this.mergeReferencesWithSelected(this.state.searchReferences, references),
            selectedReferences: references,
        });
    };

    removeOrderFromList(orderNumber) {
        var ordersList = this.state.selectedOrders;

        if (ordersList.length > 0) {
            var index = ordersList.indexOf(orderNumber);

            if (index !== -1) {
                ordersList.splice(index, 1);
                this.setState({ selectedOrders: ordersList });
            }
        }
    }

    addOrderToList(orderNumber) {
        var ordersList = [...this.state.selectedOrders];

        if (ordersList !== null && ordersList.indexOf(orderNumber) < 0) {
            this.setState({ selectedOrders: ordersList.concat(orderNumber) });
        }
    }

    toggleReferences = (isChecked, selection) => {
        if (isChecked) {
            this.addReference(selection);
        } else {
            this.removeReference(selection);
        }
    };

    updateCompareOrder = (order, selection) => {
        const references = this.state.selectedReferences;
        const newOrder = references.map((ref) => {
            const parsedOrder = parseInt(order, 10) || 0;

            if (selection.order !== 0) {
                this.addOrderToList(selection.order);
            }

            if (ref.key === selection.key) {
                ref.order = parsedOrder;
            } else if (parsedOrder === ref.order) {
                ref.order = 0;
            }

            if (ref.order !== 0) {
                this.removeOrderFromList(ref.order);
            }

            return ref;
        });
        this.setState({
            selectedReferences: newOrder,
        });
    };

    updateReferences = () => {
        this.props.updateReferences(this.state.selectedReferences);
    };

    render() {
        const searchText = this.state.readableParams ? <span className="memo">Currently Showing: {this.state.readableParams}</span> : null;

        return (
            <div className="container select-references">
                <div className="button-group">
                    <button className="button -primary" onClick={this.updateReferences}>
                        Back to Coding
                    </button>
                </div>
                <div className="search-group">
                    <h3>Search For References</h3>
                    <div className="input-group">
                        <Input name="search_upc" label="UPC" />
                        <Input name="search_manufacturer" label="Manufacturer" />
                        <Input name="search_brand" label="Brand" />
                        <Input name="search_description" label="Description" />
                        <button className="button" onClick={this.onSearch}>
                            Search
                        </button>
                    </div>
                    <h4>Results {searchText}</h4>
                    <ReactTable
                        data={this.state.searchReferences}
                        columns={searchRefColumns(this.toggleReferences)}
                        minRows="5"
                        showPagination={true}
                    />
                    {/* <button className="button">Add Selected To References</button> */}
                </div>
                <div className="group">
                    <h3>Current References</h3>
                    <ReactTable
                        data={this.state.selectedReferences}
                        columns={currentRefColumns(this.removeReference, this.updateCompareOrder)}
                        minRows="5"
                        showPagination={false}
                    />
                </div>
                <div className="button-group">
                    <button className="button -primary" onClick={this.updateReferences}>
                        Back to Coding
                    </button>
                </div>
            </div>
        );
    }
}

export default SelectReferences;
